import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import GenericModal from "@Shared/components/modals/generic-modal";

//PAGES
import ESignStartPage from "./e-sign-components/e-sign-start-page";
import ESignSelectFilesPage from "./e-sign-components/e-sign-select-files-page";
import ESignOrderFilesPage from "./e-sign-components/e-sign-order-files-page";
import ESignPackageListPage from "./e-sign-components/e-sign-package-list-page";
import ESignAddSignatureFieldsPage from "./e-sign-components/e-sign-add-signature-fields-page";
import ESignSelectSignersPage from "./e-sign-components/e-sign-select-signers-page";
import ESignAddTemplateDataPage from "./e-sign-components/e-sign-add-template-data-page";
import ESignDocumentsOnTheGoPage from "./e-sign-components/e-sign-documents-on-the-go-page";
import ESignAddRolesPage from "./e-sign-components/e-sign-add-roles-page";
import ESignSelectTemplatePage from "./e-sign-components/e-sign-select-template-page";
import ESignManageTemplatesPage from "./e-sign-components/e-sign-manage-templates-page";
import ESignSelectAgentPage from "./e-sign-components/e-sign-select-agent-page";

//LOADERS
import DefaultLoader from "./e-sign-components/loaders/default-loader";
import PackageListLoader from "./e-sign-components/loaders/package-list-loader";
import StartPageLoader from "./e-sign-components/loaders/start-page-loader";
import AddSignaturesLoader from "./e-sign-components/loaders/add-signatures-loader";
import { E_SIGNATURE_LOAD_DOCUMENTS, E_SIGNATURE_LOAD_REQUESTED_SIGNATURES, SEND_USER_DATA_REQUEST, E_SIGNATURE_UPDATE_STATUS, E_SIGNATURE_DELETE_REQUEST, E_SIGN_UPLOAD_DOCUMENT_TEMPLATE, E_SIGN_CREATE_TEMPLATE, E_SIGN_EDIT_TEMPLATE, E_SIGN_MARK_TEMPLATE_AS_COMPLETE, E_SIGN_LOAD_TEMPLATES, E_SIGN_DELETE_TEMPLATE, E_SIGNATURE_SEND_REMINDER } from "../../store/application-actions";
import { E_SIGNATURE_UPDATE_AVAILABLE_DOCUMENT } from "../../store/application-mutations";
import { showToast } from "@Shared/utils/constants";
import Err from "@Broker/js/routes/error";
import IncidentMessage from "@Broker/@Modules/status-page/components/incident-message.vue";
import AccountUsageBanner from "@Broker/@Modules/account-plan/components/account-plan-usage/account-usage-banner.vue";
import { ACCOUNT_PLAN_PAGE } from "@Broker/@Utils/enum";
import PlanSimpleButton from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-simple-button.vue";
import { LOAD_PLAN_LIMIT } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import { cloneDeep, forEach, pick, snakeCase, toUpper } from "lodash";
import { CURRENT_APPLICATION } from "../../store/application-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignModal",
  components: {
    GenericModal,
    ESignStartPage,
    ESignSelectFilesPage,
    ESignOrderFilesPage,
    ESignPackageListPage,
    ESignAddSignatureFieldsPage,
    ESignSelectSignersPage,
    ESignAddTemplateDataPage,
    ESignDocumentsOnTheGoPage,
    ESignAddRolesPage,
    DefaultLoader,
    PackageListLoader,
    StartPageLoader,
    AddSignaturesLoader,
    ESignSelectTemplatePage,
    ESignManageTemplatesPage,
    ESignSelectAgentPage,
    IncidentMessage,
    AccountUsageBanner,
    PlanSimpleButton
  },
  props: {
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      eSignDisabled: false,
      loading: true,
      reminding: {},
      modalOpened: false,
      currentStep: 0,
      stepsByFlow: {
        manageTemplates: [{
          key: "manage-templates",
          include: true
        }, {
          key: "add-template-data",
          include: true
        }, {
          key: "documents-on-the-go",
          include: true
        }, {
          key: "add-roles",
          include: true
        }, {
          key: "add-signature-fields",
          include: true
        }],
        createESignPackage: [{
          key: "select-template",
          include: true
        }, {
          key: "select-files",
          include: true
        }, {
          key: "order-files",
          include: true
        }, {
          key: "select-signers",
          include: true
        }, {
          key: "select-agent",
          include: true
        }, {
          key: "add-signature-fields",
          include: true
        }]
      },
      flow: "",
      currentTemplateData: {
        eSignTemplateId: "",
        name: "",
        description: null,
        files: [],
        title: null,
        message: null,
        subject: null,
        signerRoles: [],
        isApplicationIdIncluded: false
      },
      requestedData: [],
      signers: {},
      requesterUsername: this.agentUsername,
      validStep: true,
      uploadingDocument: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [CURRENT_APPLICATION])), mapFields("ApplicationStore", {
    selectedDocuments: "eSign.selectedDocuments",
    availableDocuments: "eSign.availableDocuments"
  })), mapState("ApplicationStore", {
    clientApplicationRequests(state) {
      return state.eSign.clientApplicationRequests;
    },
    templates(state) {
      return state.eSign.templates;
    }
  })), {}, {
    mainApplicant() {
      return this.CURRENT_APPLICATION["main-applicant"]["personal-details"];
    },
    coApplicants() {
      const coapps = this.CURRENT_APPLICATION["co-applicants"];
      return _mapInstanceProperty(coapps).call(coapps, cA => cA["personal-details"]);
    },
    accountPlanPage() {
      return ACCOUNT_PLAN_PAGE.E_SIGN;
    },
    currentLoaderComponent() {
      if (this.currentStep === this.pageRefs.START_PAGE) return "start-page-loader";
      if (this.currentStep === this.pageRefs.PACKAGE_LIST_PAGE) return "package-list-loader";
      if (this.currentStep === this.pageRefs.ADD_SIGNATURE_FIELDS_PAGE) return "add-signatures-loader";
      return "default-loader";
    },
    showControlButtons() {
      return this.pageRefs.ADD_SIGNATURE_FIELDS_PAGE !== this.currentStep;
    },
    showSteps() {
      return this.currentStep !== 0;
    },
    isAddSignatureFieldsPage() {
      return this.currentStep === this.pageRefs.ADD_SIGNATURE_FIELDS_PAGE;
    },
    modalSize() {
      return this.isAddSignatureFieldsPage ? "xl" : "lg";
    },
    modalClass() {
      return this.isAddSignatureFieldsPage ? "add-signature-modal" : "";
    },
    mainSigner() {
      const {
        email,
        "first-name": firstName,
        "last-name": lastName
      } = this.mainApplicant;
      return {
        email,
        name: `${firstName} ${lastName}`,
        role: ""
      };
    },
    coSigners() {
      var _context;
      return _mapInstanceProperty(_context = this.coApplicants).call(_context, coApplicant => {
        var _context2;
        const {
          email,
          "first-name": firstName,
          "last-name": lastName
        } = coApplicant;
        return {
          email,
          name: _trimInstanceProperty(_context2 = `${firstName} ${lastName}`).call(_context2),
          role: ""
        };
      });
    },
    currentPage() {
      return `e-sign-${this.steps[this.currentStep]}-page`;
    },
    hideFooter() {
      return this.currentStep === this.pageRefs.START_PAGE;
    },
    currentPageIsListPage() {
      return this.currentStep === this.pageRefs.PACKAGE_LIST_PAGE;
    },
    canContinue() {
      return this.validStep;
    },
    defaultPage() {
      return this.clientApplicationRequests.allIds.length ? "package-list" : "start";
    },
    steps() {
      if (!this.flow) return [this.defaultPage];
      const currentStepsByFlow = this.stepsByFlow[this.flow];
      const includedSteps = _reduceInstanceProperty(currentStepsByFlow).call(currentStepsByFlow, (acc, step) => {
        if (step.include) {
          acc.push(step.key);
        }
        return acc;
      }, []);
      return [this.defaultPage, ...includedSteps];
    },
    pageRefs() {
      const references = {};
      forEach(this.steps, step => {
        var _context3;
        references[`${toUpper(snakeCase(step))}_PAGE`] = _indexOfInstanceProperty(_context3 = this.steps).call(_context3, step);
      });
      return references;
    },
    nextStepButtonText() {
      return this.currentStep === this.pageRefs.MANAGE_TEMPLATES_PAGE ? this.$t("templates.actions.createTemplate") : this.$t("request-package.steps.nextStep");
    },
    previousStepButtonText() {
      return this.currentStep === this.pageRefs.MANAGE_TEMPLATES_PAGE ? this.$t("global.words.back") : this.$t("request-package.steps.previousStep");
    },
    modalTitle() {
      var _context4;
      const titlesByFlow = {
        manageTemplates: this.$t("e-sign-package.eSignTemplates"),
        createESignPackage: this.$t("e-sign-package.eSign")
      };
      const currentPageRef = _findInstanceProperty(_context4 = _Object$keys(this.pageRefs)).call(_context4, pageRef => this.currentStep === this.pageRefs[pageRef]);
      const titlesByPage = {
        ADD_TEMPLATE_DATA_PAGE: this.$t("e-sign-package.actions.createESignTemplate"),
        DOCUMENTS_ON_THE_GO_PAGE: this.$t("e-sign-package.eSignTemplateDocuments"),
        ADD_ROLES_PAGE: this.$t("e-sign-package.actions.createTemplateSignerTypes"),
        SELECT_TEMPLATE_PAGE: this.$t("e-sign-package.actions.selectESignTemplate")
      };
      return titlesByPage[currentPageRef] || titlesByFlow[this.flow] || this.$t("e-sign-package.eSign");
    }
  }),
  watch: {
    currentStep(value, oldValue) {
      if (value === oldValue) return;
      if (value === 0 || value === this.pageRefs.MANAGE_TEMPLATES_PAGE) {
        this.resetFields();
        this.initSigners();
      }
      if (value === this.pageRefs.SELECT_SIGNERS_PAGE) {
        forEach(this.signers, signer => {
          if (signer.role && signer.role !== "Client") return;
          signer.role = this.currentTemplateData.eSignTemplateId ? "" : "Client";
        });
      }
      if (value === this.pageRefs.ADD_SIGNATURE_FIELDS_PAGE && oldValue !== this.pageRefs.MANAGE_TEMPLATES_PAGE) {
        return this.submit();
      }
    },
    templates: {
      handler(value) {
        var _context5;
        const selectTemplateStep = _findInstanceProperty(_context5 = this.stepsByFlow.createESignPackage).call(_context5, step => step.key === "select-template");
        selectTemplateStep.include = !!value.allIds.length;
      },
      immediate: true
    },
    selectedDocuments: {
      handler(value) {
        var _context6;
        const orderFilesStep = _findInstanceProperty(_context6 = this.stepsByFlow.createESignPackage).call(_context6, step => step.key === "order-files");
        orderFilesStep.include = value.length > 1;
      },
      immediate: true
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountPlanStore", [LOAD_PLAN_LIMIT])), mapActions("ApplicationStore", [E_SIGNATURE_LOAD_DOCUMENTS, E_SIGNATURE_LOAD_REQUESTED_SIGNATURES, SEND_USER_DATA_REQUEST, E_SIGNATURE_UPDATE_STATUS, E_SIGNATURE_DELETE_REQUEST, E_SIGN_UPLOAD_DOCUMENT_TEMPLATE, E_SIGN_CREATE_TEMPLATE, E_SIGN_EDIT_TEMPLATE, E_SIGN_MARK_TEMPLATE_AS_COMPLETE, E_SIGN_LOAD_TEMPLATES, E_SIGN_DELETE_TEMPLATE, E_SIGNATURE_SEND_REMINDER])), mapMutations("ApplicationStore", [E_SIGNATURE_UPDATE_AVAILABLE_DOCUMENT])), {}, {
    handleShow() {
      this.modalOpened = true;
      this.init();
    },
    handleHidden() {
      this.modalOpened = false;
      this.currentStep = 0;
      this.resetFields();
    },
    async init() {
      this.loading = true;
      await _Promise.all([this.LOAD_PLAN_LIMIT(this.accountPlanPage), this.E_SIGNATURE_LOAD_REQUESTED_SIGNATURES({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      }), this.E_SIGNATURE_LOAD_DOCUMENTS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      }), this.E_SIGN_LOAD_TEMPLATES()]);
      this.resetFields();
      this.initSigners();
      this.loading = false;
    },
    initSigners() {
      var _context7;
      this.signers = _reduceInstanceProperty(_context7 = cloneDeep([this.mainSigner, ...this.coSigners])).call(_context7, (acc, signer) => {
        if (signer.email && signer.name) {
          acc[signer.email] = signer;
        }
        return acc;
      }, {});
    },
    resetFields() {
      this.signers = {};
      this.selectedDocuments = [];
      this.currentTemplateData = {
        eSignTemplateId: "",
        name: "",
        description: null,
        files: [],
        title: null,
        message: null,
        subject: null,
        signerRoles: [],
        isApplicationIdIncluded: false
      };
    },
    handleApplicationIdIncludeValue(value) {
      this.currentTemplateData.isApplicationIdIncluded = value;
    },
    startPackageCreation() {
      this.currentStep = this.pageRefs.SELECT_FILES_PAGE;
    },
    startLoadIframe() {
      this.currentStep = this.pageRefs.ADD_SIGNATURE_FIELDS_PAGE;
    },
    nextStep() {
      this.currentStep += 1;
    },
    prevStep() {
      this.currentStep -= 1;
    },
    handleDocumentsChange(documentList) {
      this.selectedDocuments = documentList;
    },
    handleSelectAllDocuments(select) {
      this.selectedDocuments = select ? this.availableDocuments.allIds : [];
    },
    handleSignersChange(signers) {
      this.signers = signers;
    },
    handleRequesterChange(username) {
      this.requesterUsername = username;
    },
    hideESignModal() {
      this.$refs.eSignModal.hide();
    },
    submit() {
      switch (this.flow) {
        case "manageTemplates":
          this.submitCreateTemplate();
          break;
        case "createESignPackage":
          this.submitPackage();
          break;
      }
    },
    async submitCreateTemplate() {
      this.loading = true;
      try {
        const response = await this.E_SIGN_CREATE_TEMPLATE({
          templateData: this.currentTemplateData
        });
        const {
          url,
          clientId,
          eSignTemplateId
        } = response;
        this.currentTemplateData = _objectSpread(_objectSpread({}, this.currentTemplateData), {}, {
          eSignTemplateId
        });
        this.requestedData = {
          response: [{
            value: {
              url,
              clientId
            }
          }]
        };
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loading = false;
      }
    },
    async submitPackage() {
      this.loading = true;
      try {
        var _context8;
        const appendInfo = this.currentTemplateData.eSignTemplateId ? ["templateId", "title", "message", "isApplicationIdIncluded"] : [];
        const data = _objectSpread({
          signers: _Object$values(this.signers),
          documents: _mapInstanceProperty(_context8 = this.selectedDocuments).call(_context8, dId => ({
            documentId: this.availableDocuments.byId[dId].documentId,
            fileName: this.availableDocuments.byId[dId].fileName
          })),
          agentUsername: this.requesterUsername
        }, pick(this.currentTemplateData, appendInfo));
        const {
          response,
          clientApplicationRequestIds
        } = await this.SEND_USER_DATA_REQUEST({
          applicationId: this.applicationId,
          data,
          type: "e-sign",
          clientUsername: this.clientUsername
        });
        const errorsFromResponse = this.requestedDataWithErrors(response);
        if (errorsFromResponse.length) {
          throw {
            code: "RequestDataError",
            error: errorsFromResponse[0]
          };
        }
        this.requestedData = {
          response,
          clientApplicationRequestIds
        };
      } catch (e) {
        this.handleFatalError(e);
      } finally {
        this.loading = false;
      }
    },
    handleRequestComplete({
      title,
      message
    }) {
      const [clientApplicationRequestId] = this.requestedData.clientApplicationRequestIds;
      this.updateApplicationRequest(clientApplicationRequestId, "sent", {
        message,
        subject: title
      });
      this.hideESignModal();
      showToast("success", "requestSent");
    },
    handleRequestCancel() {
      const [clientApplicationRequestId] = this.requestedData.clientApplicationRequestIds;
      this.cancelApplicationRequest(clientApplicationRequestId);
      showToast("info", "packageCreationCancelled");
    },
    handleCancel() {
      if (this.flow === "createESignPackage" && this.isAddSignatureFieldsPage) this.handleRequestCancel();
      this.hideESignModal();
    },
    async updateApplicationRequest(clientApplicationRequestId, status, data = {}) {
      await this.E_SIGNATURE_UPDATE_STATUS(_objectSpread({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        clientApplicationRequestId,
        status
      }, data));
      await this.LOAD_PLAN_LIMIT(this.accountPlanPage);
    },
    async cancelApplicationRequest(clientApplicationRequestId) {
      await this.E_SIGNATURE_DELETE_REQUEST({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        clientApplicationRequestId
      });
      await this.LOAD_PLAN_LIMIT(this.accountPlanPage);
    },
    async handleStatusChange({
      clientApplicationRequestId
    }) {
      const currentStatus = this.availableDocuments.byId[clientApplicationRequestId];
      try {
        const newStatus = "requested-cancel";
        this.E_SIGNATURE_UPDATE_AVAILABLE_DOCUMENT({
          clientApplicationRequestId,
          status: newStatus
        });
        await this.updateApplicationRequest(clientApplicationRequestId, newStatus);
      } catch (e) {
        this.E_SIGNATURE_UPDATE_AVAILABLE_DOCUMENT({
          clientApplicationRequestId,
          status: currentStatus
        });
      }
    },
    async handleReminder({
      clientApplicationRequestId
    }) {
      try {
        this.$set(this.reminding, clientApplicationRequestId, true);
        await this.E_SIGNATURE_SEND_REMINDER({
          clientApplicationRequestId,
          clientUsername: this.clientUsername,
          applicationId: this.applicationId
        });
        showToast("success", "reminderSent");
      } catch (e) {
        Err.handle(e);
      } finally {
        this.$set(this.reminding, clientApplicationRequestId, false);
      }
    },
    requestedDataWithErrors(response) {
      const errors = _reduceInstanceProperty(response).call(response, (acc, {
        status,
        reason
      }) => {
        if (status === "rejected") acc.push(reason);
        return acc;
      }, []);
      return errors;
    },
    handleFlowChange(flow) {
      this.flow = flow;
      this.nextStep();
    },
    handleAddRole(role) {
      this.currentTemplateData.signerRoles.push(role);
    },
    handleDeleteRole(index) {
      var _context9;
      _spliceInstanceProperty(_context9 = this.currentTemplateData.signerRoles).call(_context9, index, 1);
    },
    handleValid(valid) {
      this.validStep = valid;
    },
    async handleDocumentTemplateSelect(file) {
      this.uploadingDocument = true;
      const fileData = await this.E_SIGN_UPLOAD_DOCUMENT_TEMPLATE({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        file,
        classification: "e-sign"
      });
      this.currentTemplateData.files.push(fileData);
      this.uploadingDocument = false;
    },
    handleDocumentTemplateDelete(documentId) {
      var _context0;
      this.currentTemplateData.files = _filterInstanceProperty(_context0 = this.currentTemplateData.files).call(_context0, file => file.documentId !== documentId);
    },
    async handleFinishTemplate(templateId, action) {
      try {
        this.loading = true;
        await this.E_SIGN_MARK_TEMPLATE_AS_COMPLETE({
          templateData: _objectSpread(_objectSpread({}, this.currentTemplateData), {}, {
            templateId
          })
        });
        this.currentStep = 0;
        this.resetFields();
        this.loading = false;
        if (action === "Created") {
          showToast("success", "eSignTemplateCreated");
        } else {
          showToast("success", "eSignTemplateUpdated");
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loading = false;
      }
    },
    handleSelectTemplate(templateData) {
      this.currentTemplateData = templateData;
    },
    handleDeleteTemplate(eSignTemplateId) {
      this.E_SIGN_DELETE_TEMPLATE(eSignTemplateId);
    },
    handleError(error) {
      if (error.message === "RequestedDataError") {
        this.hideESignModal();
      }
      Err.handle(error, {}, "somethingWentWrongTryAgain");
    },
    handleFatalError(error) {
      this.hideESignModal();
      Err.handle(error);
    },
    async handleEditTemplate(eSignTemplateId) {
      this.loading = true;
      try {
        const response = await this.E_SIGN_EDIT_TEMPLATE({
          templateId: eSignTemplateId
        });
        const {
          url,
          clientId
        } = response;
        this.currentTemplateData = _objectSpread(_objectSpread({}, this.currentTemplateData), {}, {
          eSignTemplateId
        });
        this.requestedData = {
          response: [{
            value: {
              url,
              clientId,
              isEdit: true
            }
          }]
        };
        this.startLoadIframe();
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loading = false;
      }
    },
    handleIncidentUpdate(hasIncident) {
      this.eSignDisabled = hasIncident;
    }
  })
});